/**
 * Grand Quack Auto — 3-2-1 countdown sequence.
 *
 * Shown after the boot splash fades out. Plays beep tones, displays a
 * random cinematic tagline, then starts the game loop.
 */

import { startGameLoop } from '../gameLoop';
import type { World } from '../types';
import { getCtx, getDestination, getHtmlVolume } from '../utils/audioMixer';

function beep(freq: number, dur: number): void {
  try {
    const ctx = getCtx();
    const osc = ctx.createOscillator();
    osc.type = 'square';
    osc.frequency.value = freq;
    const g = ctx.createGain();
    g.gain.setValueAtTime(0.15, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + dur);
    osc.connect(g).connect(getDestination());
    osc.start(); osc.stop(ctx.currentTime + dur);
  } catch { /* no audio */ }
}

export function showCountdown(world: World): void {
  const messages = [
    'THE CITY ISN\'T READY',
    'RELEASE THE DUCK',
    'CAUSE MAXIMUM CHAOS',
    'NOBODY IS SAFE',
    'DUCK CRIME BEGINS NOW',
  ];
  const msg = messages[Math.floor(Math.random() * messages.length)]!;

  const el = document.createElement('div');
  el.id = 'countdown';
  document.body.appendChild(el);

  // 3...
  el.innerHTML = '<div class="cd-num">3</div>';
  beep(440, 0.15);

  setTimeout(() => { el.innerHTML = '<div class="cd-num">2</div>'; beep(440, 0.15); }, 800);
  setTimeout(() => { el.innerHTML = '<div class="cd-num">1</div>'; beep(440, 0.15); }, 1600);
  setTimeout(() => {
    el.innerHTML = `<div class="cd-go">QUACK!</div><div class="cd-msg">${msg}</div>`;
    beep(880, 0.3);
    const q = new Audio('/sounds/quack.mp3');
    q.volume = getHtmlVolume(1); q.play().catch(() => {});
  }, 2400);
  setTimeout(() => {
    el.remove();
    startGameLoop(world);
  }, 3200);
}
